import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
	name: 'dayOfTheWeek'
})
export class DayOfTheWeekPipe implements PipeTransform {

	transform(unix:number, capitalized=true) : string {
		if (!unix)
			return "";
			
		let day = moment(unix).day();
		let d : string;

		switch (day) {
			case 0 : {
				d = "domingo";
				break;
			}
			case 1 : {
				d = "lunes";
				break;
			}
			case 2 : {
				d = "martes";
				break;
			}
			case 3 : {
				d = "miércoles";
				break;
			}
			case 4 : {
				d = "jueves";
				break;
			}
			case 5 : {
				d = "viernes";
				break;
			}
			case 6 : {
				d = "sábado";
				break;
			}
			default : {
				d = "";
			}
		}
		if (capitalized)
			d = d.charAt(0).toUpperCase() + d.slice(1);

		return d;
	}

}
